module.exports = __webpack_public_path__ + "df596f7fd530d6f370ef9389ca1322cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/history/1.jpg
// module id = 327
// module chunks = 0